import { IProductDataV2, Product } from '@df/catalog/product/product';
import { NICmsContentField } from '@icms/core/content';

export namespace NShopThisLook {
    export const MODAL_ID = 'shop-this-look-modal';

    export interface IData {
        shopThisLookProducts?: number[];
        shopThisLookProductsSkus?: string[];
        shopThisLookTop?: boolean;
        shopThisLookLeft?: boolean;
    }

    export interface IModalData {
        title: string;
        products: Product<IProductDataV2>[];
    }

    export const fields = [
        {
            key: 'shopThisLookLabel',
            type: NICmsContentField.EFieldType.label,
            title: 'Shop this look'
        },
        <NICmsContentField.IRelationField>{
            key: 'shopThisLookProducts',
            type: NICmsContentField.EFieldType.relation,
            title: 'Tray products',
            options: {
                title: 'Product',
                type: 'product',
                multiple: true,
                qty: 10
            },
            multiple: true
        },
        <NICmsContentField.IToggleField>{
            key: 'shopThisLookTop',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Vertical position',
            labels: { true: 'Top', false: 'Bottom' },
            default: false
        },
        <NICmsContentField.IToggleField>{
            key: 'shopThisLookLeft',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Horizontal position',
            labels: { true: 'Left', false: 'Right' },
            default: false
        }
    ];
}
